/**
 * @description Город.
 * @param {string} id   Идентификатор.
 * @param {string} name Название.
 * @constructor
 */
function City(id, name) {
  /**
   * @description Идентификатор.
   * @type {string}
   */
  this.id = id;

  /**
   * @description Название.
   * @type {string}
   */
  this.name = name;
}

/**
 * @description Шлюз городов.
 * @param {Axios} axios HTTP клиент.
 * @constructor
 */
export default function CityGateway(axios) {
  /**
   * @description Получить список городов.
   * @returns {Promise<City[]>}
   */
  this.getAll = async () => {
    const response = await axios.get('/api/cities');
    return (response.data || []).map(({ id, name }) => new City(id, name));
  };
}
